<!-- 平水江水库 -->
<template>
  <div class="leftpic2 1">
    <div id="myChart" ref="myChart"></div>
    <div class="nowWaterLevel">
      实时水位：
      <b>{{echartData.z}}</b> m
    </div>
    <div class="leftMask"></div>
    <div class="waterLevelInfo">
      <p class="total-capacity">
        <span>当前库容</span>
        <span>{{echartData.storage}}万m³</span>
      </p>
      <p class="total-capacity">
        <span>蓄水率</span>
        <span>{{impoundmentRate}}%</span>
      </p>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import homepageTypes from '@/store/types/homepage'

// 导入echarts
let echarts = require('echarts/lib/echarts')

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      echartData: {},
      sID: '',
      beginDate: '2019-06-14 00:00',
      endDate: '2019-06-14 23:00',
      stationType: '2',
      waterFactor: ''
    }
  },
  props: ['sTID', 'deadWaterLevel', 'yMax', 'yMin', 'impoundmentRate'],
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    sTID: function () {
      this.getNowDate()
    }
  },
  // 方法集合
  methods: {
    // 获取水库水位
    getHourlyRiverLevelData () {
      this.$store
        .dispatch(homepageTypes.GET_LATEST_WATER_LEVEL, {
          sID: this.sID,
          sTID: this.sTID,
          stationType: this.stationType,
          waterFactor: this.waterFactor
        })
        .then(data => {
          this.echartData = data.rows[0]
          let chartData = []
          // 重新赋值当前水位的所有数据为当前水位数据
          for (let i = 0; i < 6; i++) {
            chartData.push(this.echartData.z)
            chartData.push(this.echartData.z + 0.5)
          }
          this.drawCharts(chartData)
        })
    },
    // 水库水位图表
    drawCharts (chartData) {
      let myChart = echarts.init(document.getElementById('myChart'))
      myChart.setOption({
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0'
        },
        xAxis: {
          show: false,
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        },
        yAxis: {
          show: false,
          type: 'value',
          max: this.yMax,
          min: this.yMin
        },
        series: [
          {
            name: '当前水位',
            smooth: true,
            symbolSize: 0,
            itemStyle: {
              normal: {
                borderWidth: 5,
                lineStyle: {
                  width: 0
                }
              }
            },
            data: chartData,
            type: 'line',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'RGBA(45,168,205,1)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'RGBA(45,168,205,.8)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            markLine: {
              symbol: ['none', 'none'], // 去掉箭头
              label: {
                position: 'end',
                formatter: '{b}:  {c}'
              },
              data: [
                [
                  {
                    name: '设计洪水位',
                    value: this.echartData.dsfllv + 'm',
                    xAxis: '0',
                    yAxis: this.echartData.dsfllv
                  },
                  {
                    name: '设计洪水位终点',
                    xAxis: '7',
                    yAxis: this.echartData.dsfllv
                  },
                  {
                    lineStyle: {
                      type: 'solid',
                      color: 'rgb(255,163,0)',
                      formatter: {
                        color: 'rgb(0,0,0)'
                      },
                      width: 2
                    }
                  }
                ],
                [
                  {
                    name: '汛限水位',
                    value: this.echartData.wrz + 'm',
                    xAxis: '0',
                    yAxis: this.echartData.wrz
                  },
                  {
                    name: '汛限水位终点',
                    xAxis: '7',
                    yAxis: this.echartData.wrz
                  },
                  {
                    lineStyle: {
                      type: 'solid',
                      color: 'rgb(248,88,87)',
                      width: 2
                    }
                  }
                ],
                [
                  {
                    name: '死水位',
                    value: this.deadWaterLevel + 'm',
                    xAxis: '0',
                    yAxis: this.deadWaterLevel
                  },
                  {
                    name: '死水位终点',
                    xAxis: '8',
                    yAxis: this.deadWaterLevel
                  },
                  {
                    lineStyle: {
                      type: 'solid',
                      color: 'rgb(255,255,0)',
                      width: 2
                    }
                  }
                ]
              ]
            }
          }
        ]
      })
    },
    // 当前日期 yy-mm-ddd h
    getNowDate () {
      var date = new Date()
      var yy = date.getFullYear()
      var mm = date.getMonth() + 1
      var dd = date.getDate()
      if (mm >= 1 && mm <= 9) {
        mm = '0' + mm
      }
      this.beginDate = yy + '-' + mm + '-' + dd + ' ' + '00:00'
      this.endDate = yy + '-' + mm + '-' + dd + ' ' + '23:00'
      this.getHourlyRiverLevelData()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.getNowDate()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" scoped>
.leftMask {
  width: 370px;
  height: 250px;
  background: #7b8fad;
  float: left;
  position: absolute;
  top: 30px;
  left: -228px;
  transform: skewX(23deg);
}
.nowWaterLevel {
  width: 250px;
  height: 30px;
  text-align: center;
  position: absolute;
  font-size: 16px;
  color: #ffffff;
  top: 0;
  left: 100px;
  b {
    color: #00deff;
    font-size: 20px;
  }
}
.waterLevelInfo {
  width: 150px;
  height: 120px;
  position: absolute;
  color: #dee5eb;
  left: 5px;
  bottom: 0;
}
.waterLevelInfo p.total-capacity,
.waterLevelInfo p.maximum-flood-discharge {
  width: 100%;
  height: 30%;
  display: block;
  font-size: 13px;
  margin: 10px 0;
  span {
    display: block;
    width: 100%;
    float: left;
  }
}
#myChart {
  width: 380px;
  height: 250px;
}
</style>
